import React, { createContext } from 'react';

import { resolve, subscribe, unpack } from './useful';
import { fdb } from './config'

const FireDataContext = createContext();
const onLocalHost = ["localhost", "127.0.0.1", ""].includes(window.location.hostname);

const logContexts = ['CaseInfoPage', 'ErrorLogPage'];

const pledge = (fn) => {
    return new Promise((resolve, reject) => {
        try {
            fn()
                .then((data) => {
                    resolve(data || true);
                })
                .catch(error => {
                    reject(error);
                })
        }
        catch (error) {
            reject(error);
        }
    });
}

const update = ({ payload, path, context }) => {
    if (onLocalHost) console.log('db: update', { path, context })
    if (/undefined/.test(path)) throw new Error(`Undefined found in path: ${path}`)
    return pledge(() => {
        return resolve(fdb, path).endpoint.set(payload, { merge: true });
    })
}

const insert = ({ payload, path, context }) => {
    if (onLocalHost) console.log('db: insert', { path, context })
    if (/undefined/.test(path)) throw new Error(`Undefined found in path: ${path}`)
    return pledge(() => {
        const { type, endpoint } = resolve(fdb, path);
        if (type === 'collection') {
            // if inserting to a collection then let firebase create the doc id
            return endpoint.add(payload);
        }
        else {
            // assume the new id was provided by the caller in the path 
            return endpoint.set(payload);
        }
    })
}

const remove = ({ path, context }) => {
    if (onLocalHost) console.log('db: remove', { path, context });

    if (/undefined/.test(path)) throw new Error(`Undefined found in path: ${path}`)
    return pledge(() => {
        return resolve(fdb, path).endpoint.delete();
    })
}

const all = async ({ path, context }) => {
    if (onLocalHost || /undefined/.test(path)) console.log('db: all', { path, context });
    const data = await pledge(() => {
        return resolve(fdb, path).endpoint.get();
    });

    return unpack(data);
}

const subcollection = async ({ path, context = '' }) => {
    if (onLocalHost || /undefined/.test(path)) console.log('db: subcollection', { path, context });

    const data = await pledge(() => {
        return fdb.collectionGroup(path).get();
    });

    return unpack(data);
}

const referrals = async ({ context = '' }) => {
    if (onLocalHost && logContexts.includes(context)) console.log('db: referrals', { context });

    // we only want referrer referrals - not the member rfq equivalent
    const data = await pledge(() => {
        return fdb.collectionGroup('referrals').get();
        // .where('courtCaseId', '>', '.')
    });

    return unpack(data);
}
const get = async ({ path, query, size, context, unarchive = false }) => {
    if (onLocalHost && logContexts.includes(context)) console.log('db: get', { path, query, size, context });
    
    if (/undefined/.test(path)) {
        throw new Error(path);
    }
    const { endpoint, type } = resolve(fdb, path);

    const result = await pledge(() => {
        if (!query) {
            return size ? endpoint.get().limit(size) : endpoint.get();
        }
        else {
            const { field, operator, value } = query;
            return size ? endpoint.where(field, operator, value).orderBy(field).limit(size).get() : endpoint.where(field, operator, value).get();
        }
    })

    return type === 'collection' ? unpack(result, unarchive) :
        result.data() ?
            { ...result.data(), id: result.id, _docPath: result.ref.path }
            : undefined;
}

const places = async ({ name, size = 10 }) => {
    const { endpoint } = resolve(fdb, 'places');

    const result = await pledge(() => {
        return endpoint.where('name', '>=', name).where('name', '<=', 'ZZZZZZZZZZZZZ').orderBy('name').limit(size).get()
    })

    return unpack(result);
}

const db = {
    resolve: path => resolve(fdb, path),
    subscribe: ({ path, hook, context }) => subscribe({ db: fdb, path, hook, context }),
    unpack,
    update,
    insert,
    remove,
    all,
    get,
    batch: fdb.batch,
    places,
    subcollection,
    referrals
}

const FireDataContextProvider = ({ children }) => {
    return (
        <FireDataContext.Provider value={db}>
            {children}
        </FireDataContext.Provider>
    );
}

export default FireDataContext;

export { FireDataContextProvider, db }